export default "__VITE_ASSET__DfNjSZzz__"